import _ from 'lodash';
import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl() {
    return `${window.api_url}/providers`;
  },

  destroy(id) {
    return axios.delete(`${this.baseUrl()}/${id}`).catch(handleError);
  },

  get(id, success) {
    if (success) return axios.get(`${this.baseUrl()}/${id}`).then(success);

    return axios.get(`${this.baseUrl()}/${id}`).catch(handleError);
  },

  index(query, success) {
    axios.get(`${this.baseUrl()}?query=${query}`).then(success);
  },

  opening: {
    baseUrl(providerId) {
      return `${window.api_url}/providers/${providerId}/openings`;
    },

    create(providerId, opening, success, failure) {
      if (!success) return axios.post(this.baseUrl(providerId), { opening }).catch(handleError);
      axios.post(this.baseUrl(providerId), { opening }).then(success).catch(failure);
    },

    destroy(providerId, id, success) {
      if (!success) return axios.delete(`${this.baseUrl(providerId)}/${id}`).catch(handleError);
      axios
        .delete(`${this.baseUrl(providerId)}/${id}`)
        .then(success)
        .catch(handleError);
    },

    index(providerId, success) {
      if (!success) return axios.get(this.baseUrl(providerId)).catch(handleError);
      axios.get(this.baseUrl(providerId)).then(success);
    },

    update(providerId, id, opening, success = _.identity, failure = handleError) {
      return axios
        .patch(`${this.baseUrl(providerId)}/${id}`, { opening })
        .then(success)
        .catch(failure);
    },

    updateOrCreate(providerId, opening, success, failure) {
      if (opening.id) {
        this.update(providerId, opening.id, opening, success, failure);
      } else {
        this.create(providerId, opening, success, failure);
      }
    },
  },

  staff_member: {
    baseUrl(providerId) {
      return `${window.api_url}/providers/${providerId}/staff_members`;
    },

    create(providerId, staff_member, success, failure) {
      axios.post(this.baseUrl(providerId), { staff_member }).then(success).catch(failure);
    },

    destroy(providerId, id, success) {
      axios.delete(`${this.baseUrl(providerId)}/${id}`).then(success);
    },

    index(providerId, success) {
      axios.get(this.baseUrl(providerId)).then(success);
    },

    update(providerId, id, staff_member, success, failure) {
      axios
        .patch(`${this.baseUrl(providerId)}/${id}`, { staff_member })
        .then(success)
        .catch(failure);
    },

    updateOrCreate(providerId, staff_member, success, failure) {
      if (staff_member.id) {
        this.update(providerId, staff_member.id, staff_member, success, failure);
      } else {
        this.create(providerId, staff_member, success, failure);
      }
    },
  },

  update(id, provider, success, failure) {
    if (!success) return axios.patch(`${this.baseUrl()}/${id}`, { provider }).catch(handleError);
    return axios.patch(`${this.baseUrl()}/${id}`, { provider }).then(success).catch(failure);
  },
};
